<template>
  <div class="contact-question-component" :class="{ shadow }">
    <div class="contact-details-container" :class="{ fullSize: !showTrainings }">
      <form class="contact-details" @submit.prevent="onSubmit">
        <div class="form-container">
          <div class="contact-name-container">
            <FormElementComponent
              name="name"
              inputType="0"
              :update="modifyInput"
              title="Nom Prénom"
              type="text"
              placeholder="Nom Prénom"
              autocomplete="name"
              :value="form.name"
              @input="form.name = $event"
              :logo="logos.logoName"
            ></FormElementComponent>
          </div>

          <div class="contact-phone-container">
            <FormElementComponent
              name="phone"
              validate=""
              inputType='1'
              :update='modifyInput'
              title='Téléphone'
              type='tel'
              inputmode='tel'
              autocomplete="tel"
              pattern="^[0-9-+s()]*$"
              placeholder='Téléphone'
              :value='form.phone'
              @input='form.phone = $event'
              :logo='logos.logoPhone'>
            </FormElementComponent>
          </div>

          <div class="contact-mail-container">
            <FormElementComponent
              name="email"
              validate="required|email"
              inputType="2"
              :update="modifyInput"
              title="E-mail*"
              type="email"
              inputmode="email"
              autocomplete="email"
              placeholder="E-mail*"
              :value="form.email"
              @input="form.email = $event"
              :logo="logos.logoEmail"
            ></FormElementComponent>
          </div>

          <div class="contact-message-container" :style="{'margin-top': marginTop + 'px' }">
            <FormElementComponent
              name="message"
              :multilines="true"
              inputType="3"
              :update="modifyInput"
              title="Message"
              type="text"
              placeholder="Message"
              :value="form.message"
              @input="form.message = $event"
              :logo="logos.logoMessage"
            ></FormElementComponent>
          </div>

          <div v-if="!showTrainings"  class="contact-send-container">
            <div class="contact-needed">
              <em>*obligatoire</em>
            </div>
            <input
              class="contact-send"
              type="submit"
              :style="{opacity: isValid()?1:0.3}"
              :disabled="!isValid()"
              value="ENVOYER"
            />
          </div>
        </div>
        <div class="spacer" v-if="showTrainings" />
        <div class="contact-trainings" v-if="showTrainings" :style="{display: 'block'}">
          <p>Quelle formation souhaitez-vous réserver ?*</p>
          <div class="contact-trainings-block-container">
            <div
              class="contact-trainings-block"
              :class="{
                isActive: training.id === form.selectedTrainingId
              }"
              v-for="(training, index) in trainings"
              :key="index"
              @click="selectTrainingId(training.id)"
            >
              <img class="training-logo" :src="training.logo">
              <div class="training-name">{{ training.name.toUpperCase() }}</div>
            </div>
          </div>
          <p>Combien de personnes participeront à la formation ?*</p>
          <div class="contact-trainings-slider-container">
            <div class="contact-training-slider">
              <vue-slider
                ref="slider"
                v-model="form.numberOfPerson"
                v-bind="options"
                :dotSize="12"
                :min="1"
                :max="20"
                :height="2"
              ></vue-slider>
            </div>
          </div>

          <div class="contact-send-container">
            <div class="contact-needed">
              <em>*obligatoire</em>
            </div>
            <input
              class="contact-send"
              type="submit"
              :style="{opacity: isValid()?1:0.3}"
              :disabled="!isValid()"
              value="ENVOYER"
            />
          </div>
        </div>
      </form>
    </div>
    <ModalComponent v-if="showModalResponse" @close="showModalResponse = false">
      <div slot="body" class="contact-modal">
        <img class="modal-icon" src="@/assets/phone-email.svg">
        <div class="modal-title" v-if="!showTrainings">MERCI POUR VOTRE MESSAGE !</div>
        <div class="modal-title" v-else>MERCI, VOTRE DEMANDE D'INSCRIPTION A ETE PRISE EN COMPTE !</div>
        <div class="modal-subtitle">Un expert de L'Atelier vous contactera prochainement</div>
      </div>
    </ModalComponent>
  </div>
</template>

<script>
import axios from 'axios'
import ModalComponent from '../ModalComponent'
import FormElementComponent from '../FormElementComponent'
import data from '@/data/fixtures'
import vueSlider from 'vue-slider-component'

export default {
  name: 'ContactQuestionComponent',
  components: {
    ModalComponent,
    FormElementComponent,
    vueSlider
  },
  props: ['showTrainings', 'allowChangeSelection', 'trainingId', 'shadow'],
  created () {
    this.form.selectedTrainingId = this.trainingId
  },
  watch: {
    trainingId (newId) {
      this.form.selectedTrainingId = newId
    }
  },
  data () {
    return {
      trainings: data.trainings,
      form: {
        errors: [],
        name: '',
        phone: '',
        email: '',
        message: '',
        selectedTrainingId: -1,
        numberOfPerson: '3'
      },
      logos: {
        logoName: require('@/assets/man.svg'),
        logoPhone: require('@/assets/phone.svg'),
        logoEmail: require('@/assets/pen.svg'),
        logoMessage: require('@/assets/envelop.svg')
      },
      showModalResponse: false,
      options: {
        bgStyle: {
          backgroundColor: '#B98A30',
          cursor: 'pointer'
        },
        sliderStyle: [
          {
            backgroundColor: '#B98A30'
          },
          {
            backgroundColor: '#B98A30',
            boxShadow: 'none'
          }
        ],
        tooltipStyle: [
          {
            backgroundColor: 'white',
            borderColor: '#B98A30',
            borderRadius: '50%'
          },
          {
            boxShadow: '0 2px 6px 0 rgba(162, 162, 162, 0.5)',
            backgroundColor: '#FFF',
            borderColor: '#B98A30',
            borderRadius: '20px',
            color: '#000',
            height: '20px',
            minWidth: '20px',
            fontWeight: 'bold'
          }
        ],
        processStyle: {
          backgroundColor: '#B98A30'
        }
      }
    }
  },

  computed: {
    marginTop () {
      const lines = this.form.message.split('\n')
      let size = lines.length
      for (const line of lines) {
        if (line.length > 30) size += Math.ceil(line.length / 30) - 1
      }

      if (size > 6) size = 6
      const isMobile = window.innerWidth <= 480

      if (isMobile) {
        return 24
      } else {
        return 128 - 24 * (size - 2)
      }
    }
  },

  methods: {
    async onSubmit () {
      this.form.errors = []

      if (!await this.$validator.validateAll()) return

      this.showModalResponse = true
      this.saveAndSendEmail()
      this.resetForm()

      this.errors.clear()
    },
    saveAndSendEmail () {
      const cleanForm = {}
      Object.keys(this.form).forEach(key => {
        if (this.form[key] && key !== 'errors') {
          cleanForm[key] = this.form[key]
        }
      })
      cleanForm.kind = this.showTrainings ? 'trainings' : 'contacts'

      if (this.form.selectedTrainingId) {
        const selected = this.trainings.find(t => t.id === this.form.selectedTrainingId)
        if (selected) cleanForm.trainingName = selected.name
      }

      axios.post('/api/contact', cleanForm).catch(err => {
        console.error('Erreur envoi formulaire', err)
      })
    },
    isValid () {
      if (this.showTrainings) {
        return (
          this.form.email.length > 0 &&
          this.form.selectedTrainingId &&
          this.form.numberOfPerson > 0
        )
      } else {
        return this.form.email.length > 0 && this.form.message.length > 0
      }
    },
    modifyInput (type, value) {
      switch (type) {
        case '0':
          this.form.name = value
          break
        case '1':
          this.form.phone = value
          break
        case '2':
          this.form.email = value
          break
        case '3':
          this.form.message = value
          break
        default:
          return type
      }
    },
    resetForm () {
      const self = this

      Object.keys(this.form).forEach((key, index) => {
        self.form[key] = ''
      })
    },
    selectTrainingId (id) {
      this.form.selectedTrainingId = id
    },
    validEmail (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    }
  }
}
</script>

<style>
.vue-slider-tooltip:before {
  bottom: -9px !important;
}

.vue-slider-component {
  padding: 6px 0 !important;
}

.vue-slider-tooltip {
  height: 20px !important;
  width: 20px !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
  line-height: 1 !important;
}
</style>

<style lang='scss' scoped>
.form-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @include media (phone) {
    width: 100% !important;
    margin-bottom: 24px;
    margin-top: 24px;
  }
}

.contact-question-component {
  height: fit-content;
  border-radius: 2px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  &.shadow {
    box-shadow: 0 2px 6px 0 rgba(176, 175, 175, 0.5);
  }

  .contact-details-container {
    display: flex;
    flex-direction: column;
    justify-content: center;

    background-color: #ffffff;
    border-radius: 2px;
    color: #979797;
    font-weight: 300;
    width: 100%;

    padding-top: 35px;
    padding-bottom: 47px;

    &.fullSize {
      padding-top: 47px;
      height: 495px;
    }

    @include media(phone) {
      padding-top: 0 !important;
      padding-bottom: 0;
    }

    .contact-details {
      margin: 0 64px;
      display: flex;
      box-sizing: border-box;

      >div{
        width: 50%;
        flex-grow: 1;
        min-width: 0;
        box-sizing: border-box;

        @include media(tablet) {
          width: 100%;
          flex: 0 0 100%;
        }

        &.spacer{
          @include media(tablet) {
            display: none;
          }

          width: 2px;
          margin: 0 64px;
          background-color: #d9d9d9;
        }
      }

      @include media(tablet) {
        margin: 20px;
        margin-bottom: 0;

        flex-wrap: wrap;
      }

      @include media(phone) {
        margin-left: 16px;
        margin-right: 16px;
        margin-top: 0;
      }

      .contact-container {
        padding-top: 25px;
        margin-top: 15px;

        &:first-child {
          margin-top: 0;
        }

        @include media(phone) {
          padding-top: 42px;
        }
      }

      .contact-name-container {
        @extend .contact-container;
      }

      .contact-phone-container {
        @extend .contact-container;
      }

      .contact-mail-container {
        @extend .contact-container;
      }

      .contact-message-container {
        @extend .contact-container;

        margin-top: 80px;

        @include media(phone) {
          margin-bottom: 20px;
          margin-top: 50px;
        }
      }

      .contact-trainings {
        align-self: center;
        background-color: #ffffff;
        color: #3a3635;
        letter-spacing: -0.05px;
        text-align: left;

        font-size: 14px;

        @include media(phone) {
          font-size: 15px;
        }

        .contact-trainings-block-container {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          justify-content: flex-start;
          margin-top: 20px;
          margin-bottom: 50px;

          @include media(phone) {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 8px;
            margin-top: 10px;
            margin-bottom: 32px;
          }

          .contact-trainings-block {
            display: flex;
            flex-direction: column;
            box-sizing: border-box;

            justify-content: space-around;
            align-items: center;

            width: 80px;
            height: 84px;

            padding: 6px;

            border-radius: 4px;

            text-align: center;
            box-shadow: 0 2px 6px 0 rgba(162, 162, 162, 0.5);
            background: white;

            transition: background 0.3s ease, transform 0.3s ease;
            cursor: pointer;

            @include media(phone) {
              width: 100%;
              height: 88px;
            }

            &:hover {
              background: #f7f7f7;
              transform: translateY(-2px);
            }

            &.isActive {
              border: 2px solid #B98A30;
            }

            .training-logo {
              min-height: 32px;
              max-height: 32px;
              max-width: 32px;
              padding-top: 2px;
            }

            .training-name {
              font-size: 0.65rem;
              font-weight: 900;
              word-break: break-word;
            }
          }
        }

        .contact-trainings-slider-container {
          padding-bottom: 20px;
          padding-top: 56px;
          width: 100%;

          @include media(phone) {
            padding-bottom: 5px;
            margin-bottom: 14px;
          }
        }
      }

      .contact-send-container {
        margin-top: 8px;
        text-align: center;

        @include media(phone) {
          padding-bottom: 20px;
        }

        .contact-needed {
          font-size: 0.8rem;
          text-align: right;
          margin-bottom: 20px;

          @include media(phone) {
            font-size: 0.7rem;
            margin-bottom: 20px;
          }
        }

        .contact-send {
          @extend %default-button;

          &:disabled {
            cursor: default;
            pointer-events: none;

            &:hover {
              background: none;
              color: #B98A30;
            }
          }

          border-radius: 0;
          -webkit-appearance: none;
          margin: 0 auto;
        }
      }
    }
  }

  .contact-modal {
    margin-left: 150px;
    margin-right: 150px;

    @include media(phone) {
      margin-top: 50px;
      margin-left: 5px;
      margin-right: 5px;
    }

    .modal-icon {
      margin-top: 64px;
      width: 48px;
    }

    .modal-title {
      color: #B98A30;
      font-weight: 900;
      letter-spacing: -0.05px;
      margin-top: 16px;
    }

    .modal-subtitle {
      color: #3a3635;
      font-size: 0.9rem;
      padding-bottom: 64px;
      margin-top: 8px;
    }
  }
}
</style>
